module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.layout === 'login') ? _c('LoginLayout', [_c('router-view')], 1) : (_vm.layout === 'compete' && !_vm.isMobile) ? _c('CompeteLayout', [_c('router-view')], 1) : (_vm.layout === 'school') ? _c('SchoolLayout', [_c('router-view')], 1) : (_vm.layout === 'admin') ? _c('AdminLayout', [_c('router-view')], 1) : (_vm.layout === 'default') ? _c('DefaultLayout', [_c('router-view')], 1) : (_vm.layout === 'center') ? _c('CenterLayout', [_c('router-view')], 1) : _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-259a3c0a","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 565
// module chunks = 85